import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=449545ea&scoped=true"
import script from "./LandingHeader.vue?vue&type=script&lang=js"
export * from "./LandingHeader.vue?vue&type=script&lang=js"
import style0 from "./LandingHeader.vue?vue&type=style&index=0&id=449545ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449545ea",
  null
  
)

export default component.exports